// Shared
export const SET_FILTER = 'STATISTICS/SET_FILTER'
export const TOGGLE_METRIC_HIDDEN = 'STATISTICS/TOGGLE_METRIC_HIDDEN'
export const SET_CHART_TYPE = 'STATISTICS/SET_CHART_TYPE'
export const FILTERS_APPLY = 'STATISTICS/FILTERS_APPLY'

export const RESET_FILTERS = 'STATISTICS/RESET_FILTERS'

// Main
export const MAIN_FILTERS_APPLY = 'STATISTICS/MAIN_FILTERS_APPLY'
export const SET_CHART = 'STATISTICS/SET_CHART'
export const SET_TABLE = 'STATISTICS/SET_TABLE'
export const FETCH_TABLE_START = 'STATISTICS/FETCH_TABLE_START'
export const FETCH_CHART_START = 'STATISTICS/FETCH_CHART_START'
export const FETCH_FAIL = 'STATISTICS/FETCH_FAIL'
export const DROP_TABLE_DATA = 'STATISTICS/DROP_TABLE_DATA'
export const FETCH_CHART = 'STATISTICS/FETCH_CHART'
export const FETCH_TABLE = 'STATISTICS/FETCH_TABLE'
export const FETCH_GROUPS = 'STATISTICS/FETCH_GROUPS'
export const FETCH_ACCOUNTS = 'STATISTICS/FETCH_ACCOUNTS'
export const CREATE_GROUP = 'STATISTICS/CREATE_GROUP'
export const UPDATE_GROUP = 'STATISTICS/UPDATE_GROUP'
export const UPDATE_GROUPS_BULK = 'STATISTICS/UPDATE_GROUPS_BULK'
export const UPDATE_ACCOUNT_GROUPS = 'STATISTICS/UPDATE_ACCOUNT_GROUPS'
export const UPDATE_GROUP_BY_ID = 'STATISTICS/UPDATE_GROUP_BY_ID'
export const UPDATE_GROUPS = 'STATISTICS/UPDATE_GROUPS'
export const UPDATE_ACCOUNTS = 'STATISTICS/UPDATE_ACCOUNTS'
export const UPDATE_ACCOUNT_BY_ID = 'STATISTICS/UPDATE_ACCOUNT_BY_ID'

// Account
export const ACCOUNT_FILTERS_APPLY = 'STATISTICS/ACCOUNT_FILTERS_APPLY'
export const ACCOUNT_SET_FILTER = 'STATISTICS/ACCOUNT_SET_FILTER'
export const ACCOUNT_SET_CHART = 'STATISTICS/ACCOUNT_SET_CHART'
export const ACCOUNT_SET_TABLE = 'STATISTICS/ACCOUNT_SET_TABLE'
export const ACCOUNT_FETCH_TABLE_START = 'STATISTICS/ACCOUNT_FETCH_TABLE_START'
export const ACCOUNT_FETCH_CHART_START = 'STATISTICS/ACCOUNT_FETCH_CHART_START'
export const ACCOUNT_FETCH_FAIL = 'STATISTICS/ACCOUNT_FETCH_FAIL'
export const ACCOUNT_DROP_TABLE_DATA = 'STATISTICS/ACCOUNT_DROP_TABLE_DATA'
export const SET_ACCOUNT_LOGIN = 'STATISTICS/SET_ACCOUNT_LOGIN'
export const ACCOUNT_SETUP_CHART_CONFIG = 'STATISTICS/ACCOUNT_SETUP_CHART_CONFIG'
export const ACCOUNT_FETCH_CHART = 'STATISTICS/ACCOUNT_FETCH_CHART'
export const ACCOUNT_FETCH_TABLE = 'STATISTICS/ACCOUNT_FETCH_TABLE'
export const GET_ACCOUNT_LOGIN = 'STATISTICS/GET_ACCOUNT_LOGIN'
export const FETCH_ACCOUNT_LOGIN_START = 'STATISTICS/FETCH_ACCOUNT_LOGIN_START'
export const FETCH_ACCOUNT_LOGIN_FAIL = 'STATISTICS/FETCH_ACCOUNT_LOGIN_FAIL'

// Campaign
export const CAMPAIGN_FILTERS_APPLY = 'STATISTICS/CAMPAIGN_FILTERS_APPLY'
export const CAMPAIGN_SET_FILTER = 'STATISTICS/CAMPAIGN_SET_FILTER'
export const CAMPAIGN_SET_CHART = 'STATISTICS/CAMPAIGN_SET_CHART'
export const CAMPAIGN_SET_TABLE = 'STATISTICS/CAMPAIGN_SET_TABLE'
export const CAMPAIGN_FETCH_TABLE_START = 'STATISTICS/CAMPAIGN_FETCH_TABLE_START'
export const CAMPAIGN_FETCH_CHART_START = 'STATISTICS/CAMPAIGN_FETCH_CHART_START'
export const CAMPAIGN_FETCH_FAIL = 'STATISTICS/CAMPAIGN_FETCH_FAIL'
export const CAMPAIGN_DROP_TABLE_DATA = 'STATISTICS/CAMPAIGN_DROP_TABLE_DATA'
export const SET_CAMPAIGN_LOGIN = 'STATISTICS/SET_CAMPAIGN_LOGIN'
export const CAMPAIGN_FETCH_CHART = 'STATISTICS/CAMPAIGN_FETCH_CHART'
export const CAMPAIGN_FETCH_TABLE = 'STATISTICS/CAMPAIGN_FETCH_TABLE'

// Pulse
export const PULSE_SET_FILTER = 'PULSE/SET_FILTER'
export const PULSE_SETUP_INITIAL_METRICS = 'PULSE/SETUP_INITIAL_METRICS'
export const PULSE_SET_ANALYTICS_CAMPAIGNS = 'PULSE/SET_ANALYTICS_CAMPAIGNS'
export const PULSE_ANALYTICS_CAMPAIGNS_FETCH_START = 'PULSE/ANALYTICS_CAMPAIGNS_FETCH_START'
export const PULSE_ANALYTICS_CAMPAIGNS_FETCH_FAIL = 'PULSE/ANALYTICS_CAMPAIGNS_FETCH_FAIL'
export const PULSE_SET_NEW_METRIC = 'PULSE/SET_NEW_METRIC'
export const PULSE_SET_NEW_METRICS = 'PULSE/SET_NEW_METRICS'
export const PULSE_TOGGLE_METRIC_STATUS_ACTIVE = 'PULSE/TOGGLE_METRIC_STATUS_ACTIVE'
export const PULSE_TOGGLE_METRIC_HIDDEN = 'PULSE/TOGGLE_METRIC_HIDDEN'
export const PULSE_SET_METRIC_DISABLED = 'PULSE/SET_METRIC_DISABLED'
export const PULSE_REMOVE_METRIC = 'PULSE/REMOVE_METRIC'
export const PULSE_SET_CHART_TYPE = 'PULSE/SET_CHART_TYPE'
export const PULSE_FETCH_DATA = 'PULSE/FETCH_DATA'
export const PULSE_GET_USER_ANALYTICS_CAMPAIGNS = 'PULSE/GET_USER_ANALYTICS_CAMPAIGNS'
export const PULSE_TOGGLE_METRIC_ACTIVE = 'PULSE/TOGGLE_METRIC_ACTIVE'
export const PULSE_REMOVE_USER_METRIC = 'PULSE/REMOVE_USER_METRIC'
